import { useMemo } from 'react';
export const useClassName = ({ className, append, optionalClassName, modifier, }) => {
    const appendString = useMemo(() => (append ? `__${append}` : ''), [append]);
    const modString = useMemo(() => (modifier ? `--${modifier}` : ''), [modifier]);
    const classNameWithAppend = useMemo(() => {
        if (append || modifier) {
            return `${className}${appendString}${modString}`;
        }
        return className;
    }, [append, appendString, className, modString, modifier]);
    // eslint-disable-next-line consistent-return
    const optionalClassWithAppend = useMemo(() => {
        if (optionalClassName) {
            if (append || modifier) {
                return `${optionalClassName}${appendString}${modString}`;
            }
            return optionalClassName;
        }
    }, [append, appendString, modString, modifier, optionalClassName]);
    const resultClass = useMemo(() => [classNameWithAppend, optionalClassWithAppend].join(' '), [classNameWithAppend, optionalClassWithAppend]);
    return resultClass.trim();
};
//# sourceMappingURL=index.js.map